module.exports = __webpack_public_path__ + "Assist_MH_Logo-5fc557ccf43a87b492d61e5f70fe01c6.svg";